import axios from "../http";
let module = "/dingtalk";
function login(type, authCode){
  return axios.post(module +'/login/'+ type  +'?authCode='+authCode);
}

function sign(type, data){
    return axios.post(module +'/sign/'+ type, data);
}

function bind(type, emplId){
    return axios.post(module +'/bind/'+ type + '/' + emplId);
}

function oaProcessTuition(type, data){
    return axios.post(module +'/processinstance/start/'+ type + '/' + data.clewId, data);
}

export default {
  login, sign, bind, oaProcessTuition
}
